module.exports = __webpack_public_path__ + "img/130.49a5e37c.jpg";